import script from "./NotificationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationModal.vue?vue&type=script&setup=true&lang=js"

import "./NotificationModal.vue?vue&type=style&index=0&id=14fb9fcf&lang=css"

const __exports__ = script;

export default __exports__